var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgItalian(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "182px",
    viewBox: "0 0 182 182",
    width: "182px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Italy",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.000001,174.878829 C154.955772,162.523738 180,129.186567 180,90 C180,50.8134331 154.955772,17.4762623 120,5.12117078 L120,174.878833 Z M120.000001,174.878829",
    fill: "#CA4738",
    id: "Oval-1-copy-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.000001,174.878829 C110.616633,178.195374 100.519063,180 90,180 C79.480937,180 69.3833674,178.195374 59.9999996,174.878829 L60,5.12116698 C69.3833673,1.80462645 79.480937,0 90,0 C100.519063,0 110.616633,1.80462645 120,5.12117078 L120,174.878833 Z M120.000001,174.878829",
    fill: "#FFFFFF",
    id: "Oval-1-copy-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9999996,5.12117078 C25.0442275,17.4762623 0,50.8134331 0,90 C0,129.186567 25.0442275,162.523738 59.9999996,174.878829 L60,5.12116698 Z M59.9999996,5.12117078",
    fill: "#57BB63",
    id: "Oval-1-copy-5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalian);
export default __webpack_public_path__ + "static/media/italian.873b57c29f7d7af507130aae64b2f4da.svg";
export { ForwardRef as ReactComponent };